// Translation: Password change > Landing > Form (German)
export default Object.freeze({
	form: {
		actions: {
			changePassword: ''
		},
		fields: {
			oldPassword: {
				placeholder: ''
			},
			password: {
				placeholder: ''
			},
			passwordConfirmation: {
				placeholder: ''
			}
		},
		title: ''
	}
})
